import React from "react";
import {Dialog} from 'primereact/dialog';
import {ProgressSpinner} from 'primereact/progressspinner';

export var showProgress = async function (forceShow = false) {
    this.state.count++;
    this.state.forceShow = forceShow;
    await this.setState({open: true});
};
export var hideProgress = function (forceHide = false) {
    this.state.count--;
    if (forceHide) {
        this.state.forceShow = false;
        this.setState({open: false});
    } else if (!this.state.forceShow && this.state.count <= 0) {
        this.state.count = 0;
        this.setState({open: false});
    }
};

class ProgressCustom extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            count: 0,
            open: false
        };
        showProgress = showProgress.bind(this);
        hideProgress = hideProgress.bind(this);
    }

    render() {
        return (
            <div>
                <Dialog showHeader={false} className={"progressCustom"}
                        style={{boxShadow: "none"}}
                        contentStyle={{backgroundColor: "rgb(0,0,0,0)", border: "none", boxShadow: "none"}}
                        visible={this.state.open}
                        onHide={hideProgress}
                >
                    <ProgressSpinner style={{width: '60px', height: '60px'}} strokeWidth="6"  animationDuration=".6s" />

                </Dialog>
            </div>
        );
    }
}

export default (ProgressCustom);
